import { api } from "../config/middleware";
import { API_GETBRANCHS } from "../config/api";

/**
 * @param {{ orgId: number, pageIndex: number, pageSize: number, q?: string }}
 */
export async function fetchBranch({ orgId, pageIndex, pageSize, q = "" }) {
  const res = await api.get(API_GETBRANCHS, {
    params: {
      ORGID: orgId,
      PAGE: (pageIndex ?? 0) + 1, // pageIndex เริ่ม 0
      SIZE: pageSize ?? 10,
      Q: q || "",
    },
  });

  const rows = res?.data?.data?.rows ?? [];
  const total = Number(res?.data?.data?.paging?.total ?? rows.length);
  return { rows, total };
}
